<template>
    <div
        :class="[
            'py-1.5 px-3 md:pl-3.5 md:pr-12 border-b transition-all duration-200 pointer-events-auto',
            hasBg
                ? 'bg-white dark:bg-neutral-900 border-neutral-100 dark:border-neutral-800'
                : 'bg-transparent border-transparent'
        ]"
        :style="hasBg && width >= 900 ? { marginLeft: '104px' } : {}"
    >
        <div class="relative flex items-center">
            <!-- Levé akce (mobilní layout = < 900px) -->
            <div v-if="isMobile" class="flex items-center z-10">
                <button
                    v-if="isReservationsPage"
                    class="w-9 h-9 rounded-full flex items-center justify-center text-neutral-600 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                    @click="topbarStore.openPanel()"
                ><i class="pi pi-bars !text-base"/></button>
                <div v-else id="topbar-left-actions"/>
            </div>

            <!-- Levý teleport slot pro desktop (např. vyhledávání v rezervacích) -->
            <div v-if="!isMobile" id="topbar-left-page-actions" class="flex items-center gap-2"/>

            <!-- Desktop spacer -->
            <div v-if="!isMobile" class="grow"/>

            <!-- Středový obsah -->
            <div
                :class="isMobile
                    ? 'absolute inset-0 flex items-center justify-center pointer-events-none'
                    : 'flex items-center gap-2'"
            >
                <!-- Mobilní měsíční navigace (inline ze store, okamžité bez teleport delay) -->
                <div v-if="isMobile && isReservationsPage" class="flex items-center gap-0.5 pointer-events-auto">
                    <button
                        class="w-8 h-8 rounded-full flex items-center justify-center text-neutral-500 dark:text-neutral-400 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                        @click="topbarStore.prev()"
                    ><i class="pi pi-chevron-left !text-xs"/></button>
                    <button
                        class="flex items-center gap-1 text-sm font-semibold text-neutral-900 dark:text-white tracking-tight select-none px-1 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                        @click="topbarStore.openPicker()"
                    >
                        {{ topbarStore.headerTitle }}
                        <i class="pi pi-chevron-down !text-[10px] text-neutral-400 dark:text-neutral-500"/>
                    </button>
                    <button
                        class="w-8 h-8 rounded-full flex items-center justify-center text-neutral-500 dark:text-neutral-400 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                        @click="topbarStore.next()"
                    ><i class="pi pi-chevron-right !text-xs"/></button>
                </div>
                <!-- Teleport slot pro desktop ReservationsCalendar a ostatní stránky -->
                <div id="topbar-page-actions" class="flex items-center gap-2"/>
            </div>

            <!-- Pravé akce -->
            <div :class="isMobile ? 'ml-auto' : ''" class="flex items-center gap-2">
                <Feedback/>
                <AppTopBarActions/>
            </div>
        </div>
    </div>
    <div class="menu-bar-dummy"/>
</template>

<script setup>
import Feedback from '../../feedback/Feedback.vue'
import AppTopBarActions from './AppTopBarActions.vue'
import { useReservationsTopbarStore } from '../../../../../state/reservationsTopbar.js'
import { useWindowSize } from '@vueuse/core'
import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

const topbarStore = useReservationsTopbarStore()
const { width } = useWindowSize()
const page = usePage()

defineProps({ isMobile: Boolean, hasBg: Boolean })

const isMobile = computed(() => width.value < 1024)

const isReservationsPage = computed(() =>
    page.component === 'administration/views/ReservationsView'
)
</script>

<style scoped lang="scss"></style>
